import { useState, useEffect } from 'react';
import ReactGA4 from 'react-ga4';
import { useLocation } from 'react-router-dom';

import { CATERING_PATH } from 'catering/constants/paths';
import { useAccount } from 'catering/context/providers/AccountProvider';
import {
  selectCateringLocationById,
  useCateringLocations,
  useCart
} from 'catering/hooks/query';
import { useQueryParams } from 'catering/hooks';
import { trackSinglePixelPageView } from 'bento-ordering/base/actions/tracking';
import { validateReferralSourceForMeta } from 'bento-ordering/base/utils/validateReferralSource';

export function usePageViews() {
  const location = useLocation();
  const queryParams = useQueryParams();
  const { utm_source: utmSourceQueryParam } = queryParams;
  const { googleAnalytics4Code } = useAccount();
  const [initializedPixels, setInitializedPixels] = useState([]);
  const [utmSource, setUtmSource] = useState(null);

  if (googleAnalytics4Code) {
    ReactGA4.initialize(googleAnalytics4Code);
    ReactGA4.send({
      hitType: 'pageview',
      page: `${CATERING_PATH}${location.pathname}`
    });
  }

  if (window.BentoAnalytics) {
    window.BentoAnalytics.trackPageview('', '');
  }

  let pixelId = null;

  const { data: cart } = useCart({
    select: cart => cart
  });

  let cateringLocationId = null;

  if (cart) {
    cateringLocationId = cart.catering_location;
  }

  const { data: cateringLocation } = useCateringLocations({
    select: locations => {
      const selectedLocation = selectCateringLocationById(
        locations,
        cateringLocationId
      );

      return { selectedLocation };
    }
  });

  if (cateringLocation && cateringLocation.selectedLocation) {
    const {
      fb_location_pixel_id: locationPixelId
    } = cateringLocation.selectedLocation.location;

    pixelId = locationPixelId;
  }

  useEffect(() => {
    if (utmSourceQueryParam) {
      setUtmSource(utmSourceQueryParam);
    }
  }, [utmSourceQueryParam]);

  useEffect(() => {
    const validReferralSource = validateReferralSourceForMeta(utmSource);
    if (
      pixelId &&
      !initializedPixels.includes(pixelId) &&
      validReferralSource
    ) {
      trackSinglePixelPageView(pixelId);
      setInitializedPixels([...initializedPixels, pixelId]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pixelId]);
}
